import { AssetID, ToothDetectionWithMetadata } from '../config';

export const calculateSupernumeraryIndices = (
  toothAndChangesForAsset: Map<
    AssetID,
    Map<number, ToothDetectionWithMetadata[]>
  >,
) => {
  const result = new Map<AssetID, Map<number, ToothDetectionWithMetadata[]>>();

  toothAndChangesForAsset.forEach((isoMap, assetID) => {
    const updatedIsoMap = new Map<number, ToothDetectionWithMetadata[]>();

    isoMap.forEach((detectionsForISO, isoNumber) => {
      if (detectionsForISO.length > 1) {
        const usedIndices = new Set<number>();
        detectionsForISO.forEach((item) => {
          if (!item.change && item.tooth.idx !== undefined) {
            usedIndices.add(item.tooth.idx);
          }
        });

        let nextAvailableIndex = 0;

        const updatedDetections = detectionsForISO.map((item) => {
          if (item.change) {
            while (usedIndices.has(nextAvailableIndex)) {
              nextAvailableIndex++;
            }
            const updatedChange = {
              ...item.change,
              SupernumeraryIndex: nextAvailableIndex,
            };
            usedIndices.add(nextAvailableIndex);
            nextAvailableIndex++;

            return {
              ...item,
              change: updatedChange,
            };
          }
          return item;
        });

        updatedIsoMap.set(isoNumber, updatedDetections);
      } else if (detectionsForISO.length === 1 && detectionsForISO[0].change) {
        const updatedDetection = {
          ...detectionsForISO[0],
          change: {
            ...detectionsForISO[0].change,
            SupernumeraryIndex: 0,
          },
        };
        updatedIsoMap.set(isoNumber, [updatedDetection]);
      } else {
        updatedIsoMap.set(isoNumber, detectionsForISO);
      }
    });

    result.set(assetID, updatedIsoMap);
  });

  return result;
};
